import { CreateForm } from "./CreateForm";
import { EditForm } from "./EditForm";
import { List } from "./List";

export default {
  CreateForm,
  EditForm,
  List,
};
